// Košík: vysvětlení u slevového kupónu, který na některé produkty nepadá
// Které produkty kupón vylučují, rozhoduje administrace (Produkty › Slevy, sloupec „Slevový kupón“).
// Texty jsou v administraci (HTML kód v patičce, blok .mytexts), JS je jen vykresluje.
let myCouponPending = "";

// Kupón odmítnutý, protože nepadá na žádnou položku → místo červené hlášky naše zelená
function myCouponRejected() {
    const code = myCouponPending;
    const $template = $(".mytexts .mycoupon-notice").first();
    const $msg = $(".messages .msg-error").first();

    myCouponPending = "";

    if (!code || !$template.length || !$msg.length) {
        return;
    }

    // Kupón přijatý není, hláška Shoptetu obsahuje zadaný kód (u neplatného kódu ho nemá)
    const cartInfo = getShoptetDataLayer("cartInfo") || {};
    const accepted = cartInfo.discountCoupon && cartInfo.discountCoupon.code;
    const text = $msg.text().toLowerCase();
    const match = ($template.attr("data-shoptet-text") || "").toLowerCase();

    if (accepted || !text.includes(code.toLowerCase()) || (match && !text.includes(match))) {
        return;
    }

    $msg.removeClass("msg-error").addClass("msg-success mycoupon-msg");
    $msg.find(".container > span").first().html($template.html());
}

// Procentní kupón ve smíšeném košíku → u vyloučené položky místo „0 %“ vysvětlení
function myCouponItems() {
    const $template = $(".mytexts .mycoupon-item").first();
    const cartInfo = getShoptetDataLayer("cartInfo") || {};
    const items = getShoptetDataLayer("cart") || [];

    $(".id--9 tr.removeable .mycoupon-item").remove();
    $(".id--9 tr.removeable [data-testid=cartItemDiscount]").removeClass("no-display");

    if (!$template.length || !cartInfo.discountCoupon || !cartInfo.discountCoupon.code) {
        return;
    }

    // U fixního kupónu mají všechny položky couponRatio 1 → vyloučená položka se poznat nedá
    const hasCouponItem = items.some(function (item) {
        return item.discounts && item.discounts.couponRatio < 1;
    });

    if (!hasCouponItem) {
        return;
    }

    items.forEach(function (item) {
        if (!item.discounts || item.discounts.couponRatio !== 1) {
            return;
        }

        const $row = $(".id--9 tr.removeable").has("input[name=itemId][value='" + item.itemId + "']");
        const $discount = $row.find("td.p-discount [data-testid=cartItemDiscount]");

        if ($discount.length) {
            $discount.addClass("no-display");
            $template.clone().insertAfter($discount);
        }
    });
}

document.addEventListener("shoptet.cart.ajaxSubmitForm", function () {
    const args = shoptet.scripts.arguments["shoptet.cart.ajaxSubmitForm"] || [];

    if (args[0] === shoptet.config.addDiscountCouponUrl) {
        myCouponPending = String($(args[1]).find("[name=discountCouponCode]").val() || "").trim();
    }
});

$(document).ready(function () {
    if ($(".id--9").length) {
        myCouponItems();
    }
});

document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    if ($(".id--9").length) {
        myCouponRejected();
        myCouponItems();
    }
});
